export const PROJECTS_RESET_STATE = 'PROJECTS_RESET_STATE';
export const PROJECTS_CURRENT_ITEM = 'PROJECTS_CURRENT_ITEM';

export const PROJECTS_REQUEST_LOADING = 'PROJECTS_REQUEST_LOADING';
export const PROJECTS_REQUEST_SUCCESS = 'PROJECTS_REQUEST_SUCCESS';
export const PROJECTS_REQUEST_FAILED = 'PROJECTS_REQUEST_FAILED';

export const PROJECTS_CURRENT_ACTION = 'PROJECTS_CURRENT_ACTION';
export const PROJECTS_RESET_ACTION = 'PROJECTS_RESET_ACTION';
